'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 10px !important;\n    transform: scale(0.42);\n  '], ['\n    font-size: 10px !important;\n    transform: scale(0.42);\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 16px !important;\n    transform: scale(0.7);\n  '], ['\n    font-size: 16px !important;\n    transform: scale(0.7);\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 20px !important;\n    transform: scale(0.85);\n  '], ['\n    font-size: 20px !important;\n    transform: scale(0.85);\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-size: 25px !important;\n    transform: scale(0.9);\n  '], ['\n    font-size: 25px !important;\n    transform: scale(0.9);\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  ', ';\n'], ['\n  pointer-events: none;\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var sizes = {
  small: (0, _styledComponents.css)(_templateObject),
  normal: (0, _styledComponents.css)(_templateObject2),
  large: (0, _styledComponents.css)(_templateObject3),
  giant: (0, _styledComponents.css)(_templateObject4)
};

var SwitchCheckBox = _styledComponents2.default.div(_templateObject5, function (_ref) {
  var size = _ref.size;
  return sizes[size];
});

SwitchCheckBox.propTypes = {
  size: _propTypes2.default.string
};
exports.default = SwitchCheckBox;